import { useLoaderData } from 'react-router-dom'
import { useSetAtom } from 'jotai'
import { useEffect } from 'react'
import { UserManagment } from '@justomx/webview-commons'
import type { OrderSummary } from 'types/receipt/model'
import { containerTypeAtom } from './Receipt.state'
import { useGoToOrderDetail } from './order-detail/OrderDetail.navigator'
import { useGoToReceiptType } from './receipt-type/ReceiptType.navigator'
import { useGoToTemperature } from './temperature/Temperature.navigator'
import { RECEIPT_TYPES } from 'utils/constants'
import { getLoginUrl } from 'utils/environment'
import { useGoToScanOrder } from './scan-order/ScanOrder.navigator'
import { useFeatureIsOn } from '@growthbook/growthbook-react'
import { toastError } from 'utils/toast'

export const useReceiptData = () => {
  const data = useLoaderData()
  const orderDetail = useGoToOrderDetail()
  const receiptType = useGoToReceiptType()
  const temperature = useGoToTemperature()
  const scanOrder = useGoToScanOrder()
  const setContainerType = useSetAtom(containerTypeAtom)
  const isTransfersOn = useFeatureIsOn('op_receipt_transfers')
  const isReceiptV2On = useFeatureIsOn('op_receipt_v2')

  useEffect(() => {
    setContainerType('')
  }, [])

  const onSelectOrder = (order: OrderSummary) => {
    if(isReceiptV2On && order.documentType === 'purchase_orders') {
      toastError('No es posible recibir por este modulo, debes recibirla por el modulo de Recibo v2.')
    }
    else{
      if (order.frozenOrRefrigerated) {
        temperature.go(order.receiptId, RECEIPT_TYPES[order.documentType])
      } else {
        orderDetail.go(
          RECEIPT_TYPES[order.documentType],
          order.receiptId,
          order.orderId
        )
      }
    }
  }

  const onSelectSync = async () => {
    if (isTransfersOn) {
      receiptType.go()
    } else {
      scanOrder.go('providers')
    }
  }

  const logout = () => {
    UserManagment.logout()
    window.location.href = getLoginUrl()
  }

  return {
    data,
    actions: { onSelectOrder, onSelectSync, logout }
  }
}
